import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@mui/material';

import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

import Sidebar from '@/components/Sidebar/Sidebar';

import logo from '@/assets/img/imgpsh_fullsize_anim.png';
import AdminNavbarLinks from '@/components/Navbars/AdminNavbarLinks';

let ps;

export default function Layout({ ...rest }) {
  const { routes } = rest;
  const mainPanel = React.createRef();
  const [color] = React.useState('blue');
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  React.useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current, {
      suppressScrollX: true,
      suppressScrollY: false,
    });
    document.body.style.overflow = 'hidden';
    window.addEventListener('resize', resizeFunction);
    return function cleanup() {
      ps?.destroy();
      window.removeEventListener('resize', resizeFunction);
    };
  }, [mainPanel]);

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar
        routes={routes}
        logo={logo}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div
        ref={mainPanel}
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          marginLeft: isMobile ? 0 : '260px',
          zIndex: '2',
          transition: 'margin-left 0.3s ease',
        }}>
        <div>
          <AdminNavbarLinks
            uiRole={rest.uiRole}
            handleDrawerToggle={handleDrawerToggle}
            isMobile={isMobile}
          />
        </div>
        <div
          style={{
            width: isMobile ? '100%' : 'calc(100vw - 300px)',
            margin: '0 auto',
            padding: '20px',
          }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
